import { forwardRef, PropsWithChildren } from "react";
import { MobileTitleHeaderProps } from "./types";
import { MobileHeader } from "@/components/mobile-header";
import styles from "./styles.scss";
import clsx from "clsx";

export const MobileTitleHeader = forwardRef<
  HTMLElement,
  PropsWithChildren<MobileTitleHeaderProps>
>(({ title, titleClassName, children, ...props }, ref) => {
  return (
    <MobileHeader ref={ref} {...props}>
      <h1 className={clsx(styles.headerTitle, titleClassName)}>{title}</h1>

      {children}
    </MobileHeader>
  );
});
